import React from 'react'
import PropTypes from 'prop-types'
import { ResponsiveVideo, VideoYoutubeWrapper } from './VideoYoutubeStyled'

const VideoYoutube = props => {
  const { linkEmbed } = props
  return (
    <VideoYoutubeWrapper>
      <ResponsiveVideo>
        <iframe
          src={linkEmbed}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen></iframe>
      </ResponsiveVideo>
    </VideoYoutubeWrapper>
  )
}

VideoYoutube.propTypes = {
  linkEmbed: PropTypes.string,
}

export default VideoYoutube
